import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-schedul-time-picker',
  templateUrl: './schedul-time-picker.component.html',
  styleUrls: ['./schedul-time-picker.component.scss']
})
export class SchedulTimePickerComponent implements OnInit {
  @ViewChild('panelDOM') panelDOM: ElementRef;

  @Input() show = false;
  @Input() title = null;
  @Input() date;
  @Input() allowTime = false;
  @Input() disableInit = false;
  @Input() disableFutureDates = false;
  @Input() disablePastDates = false;
  @Output() change = new EventEmitter<any>();
  selection: string;
  month: string;
  day: string;
  year: number;
  today: number;
  monthName: string;
  days = [];
  mode = 0;
  dated: any;
  monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  showPicker = false;
  setTimeForm: FormGroup;

  constructor() {
    const date = new Date();
    this.setTimeForm = new FormGroup({
      timeHr: new FormControl(date.getHours() > 12 ? date.getHours() - 12:date.getHours() == 12 ? date.getHours() - 12 : date.getHours()),
      timeMin: new FormControl(date.getMinutes()),
      timeZone: new FormControl(date.getHours() > 12 ? 12:date.getHours() == 12 ? 12 : 0),
    })
  }

  ngOnInit() {
    const date = new Date();
    this.day = ('0' + date.getDate()).substr(-2);
    this.month = ('0' + (date.getMonth() + 1)).substr(-2);
    this.year = date.getFullYear();

    const todayDate = new Date();
    const formattedToday = ('0' + todayDate.getDate()).substr(-2);
    this.today = parseInt('' + this.year + this.month + formattedToday);

    const pastDate = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);
    const pastDay = ('0' + pastDate.getDate()).substr(-2);
    const pastMonth = ('0' + (pastDate.getMonth() + 1)).substr(-2);
    const pastYear = pastDate.getFullYear();
    this.dated = parseInt('' + pastYear + pastMonth + pastDay);

    this.selection = this.day + '-' + this.month + '-' + this.year;
    this.setMonth();

    if (!this.disableInit) {
      setTimeout(() => this.close());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.show) {
      this.showPicker = changes.show.currentValue;
    }
    if (changes['date'] && changes.date.currentValue !== this.selection && !changes.date.firstChange) {
      const format = changes.date.currentValue.split('-');
      if (format.length > 0) {
        const old = format[1];
        format[1] = format[0];
        format[0] = old;
      }

      const date = new Date(format);
      this.day = ('0' + date.getDate()).substr(-2);
      this.month = ('0' + (date.getMonth() + 1)).substr(-2);
      this.year = date.getFullYear();
      this.selection = this.day + '-' + this.month + '-' + this.year;
      this.setMonth();
    }
  }

  setMonth() {
    const days = new Date(this.year, parseInt(this.month), 0).getDate();
    const pos = new Date(this.month + ' ' + 1 + ' ' + this.year).getDay();
    this.days = [];
    if (pos > 0) {
      for (let i = 0; i < pos; i++) {
        this.days.push(0);
      }
    }
    for (let i = 0; i < days; i++) {
      this.days.push(('0' + (i + 1)).substr(-2));
    }
  }

  nextMonth() {
    let month = parseInt(this.month) + 1;
    if (month > 12) {
      month = 1;
      this.year++;
    }
    this.month = ('0' + month).substr(-2);
    this.setMonth();
  }

  prevMonth() {
    let month = parseInt(this.month) - 1;
    if (month < 1) {
      month = 12;
      this.year--;
    }
    this.month = ('0' + month).substr(-2);
    this.setMonth();
  }
  pickDate(date) {
    let time = '';
    if (this.disableFutureDates && parseInt('' + this.year + this.month + date) > this.today) {
      return;
    }
    
    if (parseInt('' + this.year + this.month + date) < this.dated) {
      return;
    }
    if (this.allowTime) {
      if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)>9) && this.setTimeForm.value.timeMin<10){
        time = ' ' + (this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone) + ':' + ('0'+this.setTimeForm.value.timeMin) + ':00';
      }
      else if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)<10) &&this.setTimeForm.value.timeMin>9){
        time = ' ' + ('0'+(this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)) + ':' + this.setTimeForm.value.timeMin + ':00';
      }
      else if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)<10) &&this.setTimeForm.value.timeMin<10){
   
        time = ' ' + ('0'+(this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)) + ':' + ('0'+this.setTimeForm.value.timeMin) + ':00';
      }
      else{
       
        time = ' ' + (this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone) + ':' + this.setTimeForm.value.timeMin + ':00';
      }
    
    }

    this.change.emit(date + '-' + this.month + '-' + this.year + time);
    this.showPicker = false;
  }
  

  close(emit = true) {
    let time = '';
    if (this.allowTime) {

      if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)>9) && this.setTimeForm.value.timeMin<10){
        time = ' ' + (this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone) + ':' + ('0'+this.setTimeForm.value.timeMin) + ':00';
      }
      else if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)<10) &&this.setTimeForm.value.timeMin>9){
        time = ' ' + ('0'+(this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)) + ':' + this.setTimeForm.value.timeMin + ':00';
      }
      else if(((this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)<10) &&this.setTimeForm.value.timeMin<10){
   
        time = ' ' + ('0'+(this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone)) + ':' + ('0'+this.setTimeForm.value.timeMin) + ':00';
      }
      else{
       
        time = ' ' + (this.setTimeForm.value.timeHr + this.setTimeForm.value.timeZone) + ':' + this.setTimeForm.value.timeMin + ':00';
      }
    
    }
    if (emit) {
      
      if ((parseInt('' + this.year + this.month + this.day) > this.today) ||((parseInt('' + this.year + this.month + this.day) < this.dated))) {
        this.change.emit(this.selection + time);
      }
      
     else{
     
      this.change.emit(this.day + '-' + this.month + '-' + this.year + time);
     }
      
    } else {
    }
    this.showPicker = false;
  }
}
